/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {
  IProfileDetails,
  profileDetailsInitValues as initialValues,
} from '../../../../app/modules/accounts/components/settings/SettingsModel'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../../_metronic/layout/core'

const HeaderThema: React.FC = () => {
  const [data, setData] = useState<IProfileDetails>(initialValues)
  //eslint-disable-next-line
  const updateData = (fieldsToUpdate: Partial<IProfileDetails>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  const {setLayout} = useLayout()
  const [config, setConfig] = useState<ILayout>(getLayout())
  //eslint-disable-next-line
  const [configLoading, setConfigLoading] = useState<boolean>(false)

  const updateConfig = () => {
    if (config.aside.theme === 'dark') {
      config.aside.theme = 'light'
    } else {
      config.aside.theme = 'dark'
    }

    setConfigLoading(true)
    try {
      LayoutSetup.setConfig(config)
    } catch (error) {
      setConfig(getLayout())
    }
    setTimeout(() => {
      setLayout(config)
      setConfigLoading(false)
    }, 500)
  }

  return (
    <div className='row d-flex align-items-center mt-5'>
      <label className='col-lg-2 px-5'>
        <img
          src='https://img.icons8.com/color/48/000000/moon.png'
          alt='claro'
          width='30'
          title='Claro'
        />
      </label>

      <div className='col-lg-8 pt-mt-4 '>
        <div className='form-check form-check-solid form-switch fv-row '>
          <input
            className='form-check-input w-45px h-25px bg-primary'
            type='checkbox'
            id='allowmarketing'
            defaultChecked={true}
            onChange={(e) => {
              updateConfig()
            }}
          />
          <label className='col-lg-2 px-3 '>
            <img
              src='https://img.icons8.com/color/48/000000/sun--v2.gif'
              alt='escuro'
              width='30'
              title='Escuro'
            />
          </label>
        </div>
      </div>
      <div className='text-muted fs-7 px-20'> Tema </div>
    </div>
  )
}

export {HeaderThema}
